import Oge from './index'
const DevelopCenter = () => {
	return <Oge id="development" url="developCenter" type="null" />
}
export default DevelopCenter;